import React from "react";

export default function IsonTube2() {
  const title = "HOW TO DEEPFAKE LIKE A PRO";
  const description =
    "TLearn how deepfake technology is used in movies, content creation, and digital art — the safe and ethical way. This video explores the process, tools, and workflows professionals rely on, while highlighting important rules for privacy, consent, and responsible AI use.";
  const likes = 5435;
  const comments = 998;

  return (
    <div className="ison-tube-page">
      <div className="ison-tube-logo">ison tube</div>
      <div className="ison-tube-video-wrapper">
        {/* Možeš zameniti src sa svojim videom ili YouTube embed-om */}
        <video
          className="ison-tube-video"
          controls
          poster="/images/ison_tube_deepfake.jpg" // po želji
        >
          <source src="/images/deepfake_video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {/* ili npr:
        <iframe
          className="ison-tube-video"
          src="https://www.youtube.com/embed/dQw4w9WgXcQ"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        */}
      </div>

      <div className="ison-tube-content">
        <h1 className="ison-tube-title">{title}</h1>
        <p className="ison-tube-description">{description}</p>

        <div className="ison-tube-meta">
          <span>{likes} likes</span>
          <span>{comments} comments</span>
        </div>

        <div className="ison-tube-actions">
          <button className="ison-tube-btn ison-tube-share">Share</button>
          <button className="ison-tube-btn ison-tube-subscribe">
            Subscribe
          </button>
        </div>
      </div>
    </div>
  );
}
